import { MortgageFormValues } from '@app/sign-up/forms/mortgage.form';
import { ErrorModel } from '@shared-lib/models/error.model';

export interface SignUpMortgageState {
  entity: MortgageFormValues | null;
  loading: boolean;
  errors: ErrorModel | null;
}

export const signUpMortgageSelectorName = 'signUpMortgage';
